(function($) {
    
    function init(){

        var ioc = $('input[name="properties[infinite_options_color]"]'),
            cs = $('#SingleOptionSelector-0'),
            csVal = cs.val(),
            vn = $('#ProductSelect-product-template');
            

            function replaceUrlParam(url, paramName, paramValue)
            {
                if (paramValue == null) {
                    paramValue = '';
                }
                var pattern = new RegExp('\\b('+paramName+'=).*?(&|#|$)');
                if (url.search(pattern)>=0) {
                    return url.replace(pattern,'$1' + paramValue + '$2');
                }
                url = url.replace(/[?#]$/,'');
                return url + (url.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue;
            }

            
            $('input[name="properties[infinite_options_color]"][value="' + csVal + '"]').attr('checked', 'checked');
            
            ioc.on('change', function () {
                
                var value =  $(this).val();
                var vid =  vn.find('option:contains(' + value + ')').val();
                console.log(vid);
                
                cs.val(value).trigger('change')
                vn.val(vid).trigger('change');

                var urlVariant = replaceUrlParam(window.location.href, 'variant', vid);

                window.location.href = urlVariant;

            });
    }


    $("body").one('DOMSubtreeModified', "#infiniteoptions-container", function() {
        init();
        return false;
    });
    
})(jQuery);